import styled from 'styled-components'

export const StyledBackButton = {
  BackButton: styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
  `,
}
